import { TimeStampTopic } from 'src/lib/hooks/video-player/useTimeStampTopic';

import { ReduxState } from '../../store';

export const selectActiveTimestampTopicId = (state: ReduxState): string =>
  state.timestampReducer.activeTimestampTopicId;
export const selectOpenTimestampReportId = (state: ReduxState): string =>
  state.timestampReducer.openTimestampReportId;
export const selectTimeStampReportId = (state: ReduxState): string =>
  state.timestampReducer.timeStampReportId;
export const selectActiveTimestampTopicDetails = (state: ReduxState): TimeStampTopic =>
  state.timestampReducer.activeTimestampTopicDetails;
export const selectTimeStampList = (state: ReduxState): TimeStampTopic[] =>
  state.timestampReducer.timestampTopicList;
export const selectPlayerTotalDuration = (state: ReduxState): number =>
  state.timestampReducer.playerTotalDuration;
export const selectPlayerCurrentTime = (state: ReduxState): number =>
  state.timestampReducer.playerCurrentTime;
export const selectPlayerBufferedDuration = (state: ReduxState): number =>
  state.timestampReducer.playerBufferedDuration;
export const selectIsSubTopicSelectFromSidebar = (state: ReduxState): boolean =>
  state.timestampReducer.isSubTopicSelectFromSidebar;
export const selectIsSubtoipcTimestampFeatureEnabled = (state: ReduxState): boolean =>
  state.timestampReducer.isSubtoipcTimestampFeatureEnabled;
